import { Box, Divider } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import PropertyThumbnailWithAvatar from '../PropertyThumbnailWithAvatar';

export const ConversationItemSkeleton = () => {
  return (
    <>
      <Box
        css={{
          display: 'flex',
          gap: 'loose',
          padding: 'default',
        }}
      >
        <PropertyThumbnailWithAvatar />

        {/* Content Area */}
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'tighter',
            flex: 1,
            minWidth: 0,
          }}
        >
          <Bone type="line" css={{ width: '70%' }} />
          <Bone type="line" css={{ width: '50%' }} />
          <Bone type="line" css={{ width: '90%' }} />
        </Box>
      </Box>

      <Divider />
    </>
  );
};

export const ConversationListSkeleton = () => {
  return (
    <Box css={{ overflowY: 'auto' }}>
      {[...Array(10)].map((_, idx) => {
        return <ConversationItemSkeleton key={idx} />;
      })}
    </Box>
  );
};
